/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { ethers } from "ethers";
import { useWeb3React } from "@web3-react/core";
import styled from "styled-components";
import { isMobile } from "react-device-detect";
import { useAccount, useConnect } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";

import { API_ASDI_CMS_BASE_URL } from "../../../../../src/config/constants";
import useToast from "../../../../../src/hooks/useToast";
import { setIslogin } from "../../../../../src/state/auth/actions";
import { setAuthToken, deleteAuthToken, applyHmacAndEncryption } from "../../../../../src/library/FetchHelper";
import Grid from "../../components/Box/Grid";
import Box from "../../components/Box/Box";

import Flex from "../../components/Box/Flex";
import Text from "../../components/Text/Text";
import Heading from "../../components/Heading/Heading";
import { ModalBody, ModalContainer, ModalHeader, ModalTitle } from "../Modal";
import WalletCard, { MoreWalletCard } from "./WalletCard";
import config, { uuidDevice, walletLocalStorageKey } from "./config";
import { Config, Login } from "./types";
import { useSignMessage } from "../../../../wagmi/src/hooks/useSignMessage";

interface Props {
  login: Login;
  logout: () => void;
  onDismiss?: () => void;
  setCloseOnOverlayClick?: () => void;
  displayCount?: number;
  t: (key: string) => string;
}

const WalletWrapper = styled(Box)`
  ul {
    display: flex;
    list-style-type: none;
    background: #ffffff;
    border: 1px solid #c7c7c7;
    border-radius: 30px;
    padding: 4px;
    height: 40px;
    justify-content: space-between;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      padding: 5px 10px 5px 10px;
      cursor: pointer;
      width: 33.333%;
      border-radius: 15.5px;

      &:hover {
        background: rgba(187, 187, 187, 0.5);
      }

      img {
        height: 100%;
        width: auto;
        margin-right: 8px;
      }
    }

    li.active {
      background: #006dfe;
      color: #fff;
      transition: all 0.5s ease-in-out;
    }
  }

  .box-wallet {
    border: 1px solid #6d6d6d;
    border-radius: 10px;
    padding: 10px;
    margin-top: 12px;
  }

  .more-info {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #000000;

    a {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-align: center;
      color: #006def;
    }
  }

  .nomal-text {
    color: #000000 !important;
  }
`;

const ModalStyle = styled.div`
  position: relative;
  z-index: 1001;
  max-width: 483px;
  p {
    font-size: 14px;
    line-height: 19px;
    color: #000000;

    a {
      color: #006dfe;

      &.nomal {
        color: #000000;
        cursor: text;

        &:hover {
          color: #000000;
        }
      }
    }
  }

  button {
    &[disabled] {
      opacity: 0.5;

      &.btn-agree {
        &:hover {
          background: #006dfe;
        }
      }
      &.btn-cancel {
        &:hover {
          background: #ffffff;
        }
      }
    }

    &.btn-cancel {
      width: 150px;
      max-width: 50%;
      height: 30px;
      border: 1px solid #c7c7c7;
      font-size: 12px;
      line-height: 15px;
      cursor: pointer;
      border-radius: 5px;
      background: #ffffff;
      margin-right: 10px;
      transition: 0.2s;

      &:hover {
        background: #bbbbbb;
        border: 1px solid #d9d9d9;
      }
    }

    &.btn-agree {
      width: 150px;
      max-width: 50%;
      height: 30px;
      border: 1px solid #c7c7c7;
      font-size: 12px;
      line-height: 15px;
      cursor: pointer;
      border-radius: 5px;
      background: #006dfe;
      color: #ffffff;

      &:hover {
        background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
      }
    }
  }

  .check_and_sign {
    padding: 4px 15px;
    height: 28px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #006dfe;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #c7c7c7;
    width: fit-content;
    border-radius: 20px;
    margin: auto;
    margin-bottom: 17px;

    img {
      margin-right: 4px;
    }
  }

  .close-modal {
    position: absolute;
    right: 12px;
    cursor: pointer;
  }
  @media (max-width: 572px) {
    position: fixed;
    bottom: 0;
    min-width: 90%;
    .modal-button-confirm {
      flex-direction: column;
      gap: 12px;
      button {
        min-width: 90%;
        margin: auto;
      }
    }
  }
`;

const connector = new InjectedConnector();

/**
 * Checks local storage if we have saved the last wallet the user connected with
 * If we find something we put it at the top of the list
 *
 * @returns sorted config
 */
const getPreferredConfig = (walletConfig: Config[]) => {
  const sortedConfig = walletConfig.sort((a: Config, b: Config) => a.priority - b.priority);

  const preferredWalletName = localStorage?.getItem(walletLocalStorageKey);

  if (!preferredWalletName) {
    return sortedConfig;
  }

  const preferredWallet = sortedConfig.find((sortedWalletConfig) => sortedWalletConfig.title === preferredWalletName);

  if (!preferredWallet) {
    return sortedConfig;
  }

  return [
    preferredWallet,
    ...sortedConfig
      .filter((sortedWalletConfig) => sortedWalletConfig.title !== preferredWalletName)
      .filter((sortedWalletConfig) =>
        typeof sortedWalletConfig.mobileOnly === "boolean" ? sortedWalletConfig.mobileOnly && isMobile : true
      ),
  ];
};

const coinFilter = [
  {
    icon: "/images/coins/bnb.svg",
    label: "BNB chain",
  },
  {
    icon: "/images/coins/eth.svg",
    label: "Ethereum",
  },
  {
    icon: "/images/icons/polygon.svg",
    label: "Polygon",
  },
];

const ConnectModal: React.FC<Props> = ({ login, logout, onDismiss = () => null, displayCount = 3, t }) => {
  const dispatch = useDispatch();
  const { toastSuccess, toastError }: any = useToast();
  const { account } = useWeb3React();
  const signMessageAsync = useSignMessage();
  const { connectAsync } = useConnect();
  const { isConnected } = useAccount();

  const [showMore, setShowMore] = useState(false);
  const [view, setView] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [walletActive, setWalletActive] = useState<any>();

  const sortedConfig = getPreferredConfig(config);
  // Filter out WalletConnect if user is inside TrustWallet built-in browser
  const walletsToShow = window.ethereum?.isTrust
    ? sortedConfig.filter((wallet) => wallet.title !== "WalletConnect")
    : sortedConfig;
  const displayListConfig = showMore ? walletsToShow : walletsToShow.slice(0, displayCount);

  const [coin, setCoin] = useState({
    icon: "/images/coins/bnb.svg",
    label: "BNB chain",
  });

  const onSignature = useCallback(async () => {
    try {
      if (!isConnected) {
        const resultConnect = await connectAsync({ connector });

        if (resultConnect) {
          try {
            setLoading(true);
            const loginUUID = uuidv4();
            const message = `Welcome to Soei! Click to sign in and accept the Soei Foundation Terms of Service: https://docs.soei.social/documents-and-policies/policies This request will not trigger a blockchain transaction or cost any gas fees. Your authentication status will reset after 24 hours. Wallet address: ${account?.toLocaleLowerCase()} Nonce: ${loginUUID}`;

            const signature = await signMessageAsync({
              message,
            });

            const verify = ethers.utils.verifyMessage(message, signature as string);

            if (verify) {
              const uuidDeviceStored = localStorage.getItem(uuidDevice);

              const getUUID = uuidv4();

              if (!uuidDeviceStored) {
                localStorage.setItem(uuidDevice, getUUID);
              }

              const data = {
                walletAddress: resultConnect?.account?.toLocaleLowerCase(),
                deadline: Math.round((new Date().getTime() + 5 * 60000) / 1000),
                sig: signature,
                deviceUUID: getUUID,
                uuid: loginUUID,
              };

              const { hmac, encryptBody } = applyHmacAndEncryption(data);

              const body = JSON.stringify({
                encryptBody,
                hmac,
              });

              try {
                fetch(`${API_ASDI_CMS_BASE_URL}/auth/login`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body,
                })
                  .then((response) => response.json())
                  .then((resolve) => {
                    if (resolve?.data?.token) {
                      setAuthToken(`Bearer ${resolve?.data?.token}`);
                      setLoading(false);

                      onDismiss();
                      dispatch(setIslogin(true));
                      toastSuccess(t("Login successful"));
                    }

                    if (!resolve?.success) {
                      setLoading(false);
                      dispatch(setIslogin(false));
                      onDismiss();
                      toastError("Login has error");
                    }
                  });
              } catch (error) {
                setLoading(false);
                console.error("Login error", error);
              }
            } else {
              setLoading(false);
            }
          } catch (e: any) {
            toastError(e?.message);
            setLoading(false);
          }
        }
      } else {
        try {
          setLoading(true);
          const loginUUID = uuidv4();
          const message = `Welcome to Soei! Click to sign in and accept the Soei Foundation Terms of Service: https://docs.soei.social/documents-and-policies/policies This request will not trigger a blockchain transaction or cost any gas fees. Your authentication status will reset after 24 hours. Wallet address: ${account?.toLocaleLowerCase()} Nonce: ${loginUUID}`;
          const signature = await signMessageAsync({
            message,
          });

          const verify = ethers.utils.verifyMessage(message, signature as string);

          if (verify) {
            const uuidDeviceStored = localStorage.getItem(uuidDevice);
            const getUUID = uuidv4();

            if (!uuidDeviceStored) {
              localStorage.setItem(uuidDevice, getUUID);
            }

            const data = {
              walletAddress: account?.toLocaleLowerCase(),
              deadline: Math.round((new Date().getTime() + 5 * 60000) / 1000),
              sig: signature,
              deviceUUID: getUUID,
              uuid: loginUUID,
            };

            const { hmac, encryptBody } = applyHmacAndEncryption(data);

            const body = JSON.stringify({
              encryptBody,
              hmac,
            });

            try {
              fetch(`${API_ASDI_CMS_BASE_URL}/auth/login`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body,
              })
                .then((response) => response.json())
                .then((resolve) => {
                  if (resolve?.data?.token) {
                    setAuthToken(`Bearer ${resolve?.data?.token}`);

                    setLoading(false);
                    onDismiss();
                    dispatch(setIslogin(true));
                    toastSuccess(t("Login successful"));
                  }

                  if (!resolve?.success) {
                    setLoading(false);
                    dispatch(setIslogin(false));
                    onDismiss();
                    toastError("Login has error");
                  }
                });
            } catch (error) {
              setLoading(false);
              console.error("Login error", error);
            }
          } else {
            setLoading(false);
          }
        } catch (e: any) {
          toastError(e?.message);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Login error", error);
    }
  }, [account, connectAsync, dispatch, isConnected, onDismiss, signMessageAsync, t, toastError, toastSuccess]);

  return (
    <ModalStyle>
      <ModalContainer minWidth="0">
        <ModalHeader style={{ borderBottom: "0.5px solid #6D6D6D", paddingBottom: "8px" }}>
          <ModalTitle justifyContent="center">
            <Heading>
              <p style={{ color: "#006DFE", fontWeight: "700", fontSize: "24px", lineHeight: "30px" }}>
                {view === 0 ? t("Kết nối ví của bạn") : t("Chào mừng bạn đến với SOEI")}
              </p>
            </Heading>
          </ModalTitle>

          {view === 0 && (
            <img className="close-modal" onClick={() => onDismiss()} src="/images/icons/close.svg" alt="" />
          )}
        </ModalHeader>
        <ModalBody>
          {view === 0 ? (
            <WalletWrapper pt="14px" maxHeight="453px" overflowY="auto">
              <p style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                {t("Chọn cách bạn muốn kết nối. Có một số nhà cung cấp ví.")}
              </p>
              <ul>
                {coinFilter.map((item) => (
                  <li
                    key={item.label}
                    onClick={() => setCoin(item)}
                    className={coin.label === item.label ? "active" : ""}
                  >
                    {item.icon && <img src={item.icon} alt="" />}
                    <span>{t(item.label)}</span>
                  </li>
                ))}
              </ul>
              <Grid gridTemplateColumns="1fr 1fr" className="box-wallet">
                {displayListConfig.map((wallet) => (
                  <Box key={wallet.title}>
                    <WalletCard
                      walletConfig={wallet}
                      login={login}
                      onDismiss={onDismiss}
                      setView={setView}
                      setWalletActive={setWalletActive}
                      active={wallet.title === walletActive}
                    />
                  </Box>
                ))}
                {!showMore && <MoreWalletCard t={t} onClick={() => setShowMore(true)} />}
              </Grid>

              <Box p="24px">
                <Text
                  style={{ maxWidth: "343px", margin: "auto" }}
                  className="more-info"
                  textAlign="center"
                  color="textSubtle"
                  as="p"
                  mb="16px"
                >
                  <a className="nomal-text">
                    {t("Nếu chưa có ví, bạn có thể chọn một nhà cung cấp và tạo một ví ngay bây giờ.")}{" "}
                  </a>
                  <a
                    style={{ display: "inline" }}
                    href="https://docs.pancakeswap.finance/get-started/connection-guide"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {t("Tìm hiểu thêm!")}
                  </a>
                </Text>
              </Box>
            </WalletWrapper>
          ) : (
            <>
              <div style={{ textAlign: "center", margin: "12px 0" }}>
                {loading ? (
                  <img style={{ margin: "40px 0" }} width={50} src="/images/loading.gif" alt="" />
                ) : (
                  <img style={{ margin: "45px 0 35px 0" }} width="44px" src="/logo.png" alt="" />
                )}

                <p
                  style={{
                    textAlign: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: loading ? "23px" : "56px",
                  }}
                >
                  <a className="nomal">
                    {t("By connecting your wallet and using SOEI, it means that you agree to all of our policies.")}
                  </a>{" "}
                  <a
                    style={{ display: "inline" }}
                    href="https://docs.pancakeswap.finance/get-started/connection-guide"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {t("Tìm hiểu thêm!")}
                  </a>
                </p>

                {loading && (
                  <p className="check_and_sign">
                    <img src="/images/icons/!.svg" alt="" />
                    {t("Check and sign in your wallet")}
                  </p>
                )}

                <Flex paddingBottom="27px" justifyContent="center" className="modal-button-confirm">
                  <button
                    className="btn-cancel"
                    type="button"
                    onClick={() => {
                      logout();
                      onDismiss();
                      deleteAuthToken();
                    }}
                    disabled={loading}
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    className="btn-agree"
                    type="button"
                    onClick={() => {
                      onSignature();
                    }}
                    disabled={loading}
                  >
                    {t("Agree and Sign")}
                  </button>
                </Flex>
              </div>
            </>
          )}
        </ModalBody>
      </ModalContainer>
    </ModalStyle>
  );
};

export default ConnectModal;
